import React from 'react'
import { Flex, Box, Heading } from 'rebass/styled-components'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import SwiperCore, { Navigation } from 'swiper'
import PropTypes from 'prop-types'

import TestimonialsCard from './TestimonialsCard'
import Icomoon from '../Icomoon'

SwiperCore.use([Navigation])

const TestimonialsSection = ({ home, promo }) => {
  const { t } = useTranslation('home')

  return (
    <Box as="section" width={1} bg={home && 'lightGray'}>
      <Box
        maxWidth="container"
        width={1}
        mx="auto"
        mb={home && [-32, -37, '-200px']}
        pt={home ? [15, 26] : [10, 20]}
        px={[5, 5, 0]}
        pb={promo && [10, 20]}
        sx={{
          position: 'relative'
        }}
      >
        <Flex justifyContent="space-between" alignItems="center">
          <Heading width={['300px', '460px']} mr="auto" variant="level2">
            {home && t('reports.title')}
            {promo && t('reports.title_two')}
          </Heading>

          <Flex
            className="swiper-button-prev"
            height="60px"
            mr={10}
            bg="rgba(130,59,248, 0.1)"
            sx={{
              borderRadius: '70px',
              transition: 'all .365s ease-in-out',

              ':hover': {
                cursor: 'pointer',
                opacity: '0.5'
              },

              '::after': {
                display: 'none'
              },

              '&.swiper-button-prev': {
                position: 'relative',
                width: '60px',
                height: '60px'
              },

              '@media (max-width: 80rem)': {
                display: 'none !important'
              }
            }}
          >
            <Icomoon color="#7739EB" icon="arrow-left" size={20} />
          </Flex>

          <Flex
            className="swiper-button-next"
            bg="rgba(130,59,248, 0.1)"
            sx={{
              borderRadius: '70px',
              transition: 'all .365s ease-in-out',

              ':hover': {
                cursor: 'pointer',
                opacity: '0.5'
              },

              '::after': {
                display: 'none'
              },

              '&.swiper-button-next': {
                position: 'relative',
                width: '152px',
                height: '60px',
                fontSize: '16px',
                fontFamily: 'Poppins, sans-serif',
                color: 'purple'
              },

              '@media (max-width: 80rem)': {
                display: 'none !important'
              }
            }}
          >
            Next
            <Icomoon style={{ marginLeft: 20 }} color="#7739EB" icon="arrow-right" size={20} />
          </Flex>
        </Flex>

        <TestimonialsCard />
      </Box>
    </Box>
  )
}

TestimonialsSection.propTypes = {
  home: PropTypes.bool,
  promo: PropTypes.bool
}

export default TestimonialsSection
